import { numFormatter } from '../../shared/utils/number/formatter';
import { Tooltip } from '../../tooltip/Tooltip';

export function UsageSummaryCount({ count }: { count: number }) {
  return (
    <Tooltip dataId='' title={count}>
      <span>{numFormatter(count)}</span>
    </Tooltip>
  );
}
